import { Button, InputAdornment } from '@mui/material';
import { useTranslation } from 'react-i18next';

const styles = {
    copyButton: {
        textTransform: 'uppercase',
        borderRadius: '50px',
        width: '100%',
    },
};

type CopyButtonProps = {
    content: string;
    copyBtnStyle?: object;
};

export const CopyButton: React.FC<CopyButtonProps> = (props) => {
    const { content, copyBtnStyle } = props;
    const copyButtonStyle = copyBtnStyle ?? styles.copyButton;
    const { t } = useTranslation();

    return (
        <InputAdornment position="end">
            <Button
                sx={copyButtonStyle}
                variant="contained"
                color="primary"
                onClick={(): void => {
                    void navigator.clipboard.writeText(content);
                }}
            >
                {t('COMMON.COPY')}
            </Button>
        </InputAdornment>
    );
};
